import type { DocumentId } from '../models/session';

export const ENDPOINT_URL = {
  config: '/api/v1/configs',
  validateSessionCookie: '/api/v1/session/validate-cookie',
  paymentTerminalsInvoiceFields: '/api/v1/payment-terminals/invoice-fields',
  evse: (evsePhysicalReference: string) => `/api/v1/evses?evsePhysicalReference=${evsePhysicalReference}`,
  chargePoint: (evsePhysicalReference: string) =>
    `/api/v1/charge-points?evsePhysicalReference=${evsePhysicalReference}`,
  chargePointById: (chargePointId: string) => `/api/v1/charge-points?chargePointId=${chargePointId}`,
  chargePointResolve: (identifier: string) =>
    `/api/v1/charge-points/resolve?identifier=${encodeURIComponent(identifier)}`,
  session: (chargePointId: number, evseId: number, sessionId: string, pin?: string) => {
    const baseUrl = `/api/v1/charge-points/${chargePointId}/session/${sessionId}/evse/${evseId}`;
    return pin ? `${baseUrl}?pin=${pin}` : baseUrl;
  },
  startSession: (chargePointId: number, evseId: number) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/start`,
  stopSession: (chargePointId: number, evseId: number) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/stop`,
  translations: (languageCode: string) => `/api/v1/translations/${languageCode}`,
  stripePayments: '/api/v1/payments/stripe',
  createStripeFailedTransaction: '/api/v1/payments/stripe/failed',
  //MerchantId is required - Using secure endpoint that calculates amount server-side
  worldLinePayments: '/api/v1/payments/worldline/secure',
  getPaymentStatus: (paymentIntentId: string) => `/api/v1/payments/${paymentIntentId}/status`,
  getPaymentDbStatus: (paymentIntentId: string) => `/api/v1/payments/${paymentIntentId}/db-status`,
  getPayment: (paymentIntentId: string) => `/api/v1/payments/${paymentIntentId}/payment`,
  forgotPin: (chargePointId: number, evseId: number, last4: string, expYear: string, expMonth: string) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/pin?last4=${last4}&expYear=${expYear}&expMonth=${expMonth}`,
  updateNewPin: (chargePointId: number, evseId: number) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/pin`,
  sessionFinished: (chargePointId: number, evseId: number, sessionId: string) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/finished?sessionId=${sessionId}`,
  sessionConsumptionStats: (chargePointId: number, evseId: number, sessionId: string) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/consumption-stats?sessionId=${sessionId}`,
  checkSessionAvailability: (chargePointId: number, evseId: number) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/availability`,
  receipt: (receiptId: DocumentId) => `/api/v1/receipts/${receiptId}`,
  invoice: (invoiceId: DocumentId) => `/api/v1/invoices/${invoiceId}`,
  checkSessionByPaymentId: (paymentId: string) => `/api/v1/sessions/check-by-payment/${paymentId}`,
  cancelWorldlinePayment: (paymentId: string) => `/api/v1/payments/worldline/${paymentId}/cancel`,
  autoStartWalletSession: (chargePointId: number, evseId: number, paymentId: string) =>
    `/api/v1/charge-points/${chargePointId}/session/${evseId}/payment/${paymentId}/auto-start`,
  // SC-370525: Associate PIN with running auto-started session
  associatePinWithSession: (chargePointId: number, sessionId: string, evseId: number) =>
    `/api/v1/charge-points/${chargePointId}/session/${sessionId}/evse/${evseId}/pin`,
};
